import React from "react";

const ReleaseInfo = () => {
  return (
    <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-4 md:py-6 lg:py-16">
      <p className="text-[22px] font-bold text-[#121212] mb-[20px]">
        Release Notes: NEPTUNE 2.0 X.00-05c
      </p>
      <p className="text-[18px] font-bold text-[#121212] mb-[20px]">
        NEPTUNE 2.0 X.00-05c-April 17, 2026, 2026:
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium mb-[20px]">
        Changed HLS Video Streaming to ActiveX Video <br />
        Enhanced Elevator Output Control <br />
        SSL Update <br />
        TLS Update
      </p>
      <p className="text-[18px] font-bold text-[#121212] mb-[20px]">
        NEPTUNE 2.0 X.00-05a-April 17, 2026, 2026:
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium mb-[20px]">
        Added Sicunet Anti-virus utility. <br /> Added message to Network
        settings page:
      </p>
      <p className="text-[18px] font-bold text-[#121212] mb-[20px]">
        Important!!!
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium mb-[20px]">
        All IP addresses should be configured to a network that is within and
        protected by a network security system (Firewall,etc.) <br />
        If you require outside of firewall accessibility, contact the factory.
      </p>
      <p className="text-[#4A4C56] text-[13px] font-medium mb-[20px]">
        Changed the backup retry time from 10 seconds to 10 minutes when a
        scheduled backup fails. <br /> Modified to reboot when DB lock occurs 3
        times. <br /> Elevator Relay supports Energized/De-Energized type.{" "}
        <br /> Updated PHP <br />
        Updated Checksum with Time Limit
      </p>
    </div>
  );
};

export default ReleaseInfo;
